import { formatDateMDYYYY } from '../../utils/dateUtil';
import Storage from './storageHelper';
import { Keywords } from '../../constants/appConstants';

//Special Case pseduo EasyPayment Agreement: item.ServiceAgreementType !== Keywords.easyPay and item.autoChgAcctRef is not empty

//TypesofServiceAgreements: BadDebt,PrePay,EasyPay,Ontime,PseudoEasyPay,SpecialCase(Inactive with ammount Due)
const getServiceAgreements = (svcAgts) => {
  let salesAgreements = [] ;
  if(Array.isArray(svcAgts) || svcAgts.length>0) {
    let badDebtAgts = svcAgts.filter(item => item.isBadSalesAgreement === 'Y' && invoiceAmountDue(item) > 0 && item.inactiveReason !== 'SSP' && item.inactiveReason !== 'NRN');
    let spslAgts = svcAgts.filter(item => item.inactiveReason === 'SSP' && item.inactiveStatus === 'INA');
    let actSvcAgts = svcAgts.filter(item => item.inactiveStatus === 'ACT' && item.isBadSalesAgreement !== 'Y');
    let inActSvcAgts = svcAgts.filter(item => item.inactiveStatus === 'INA' && invoiceAmountDue(item) > 0 && item.isBadSalesAgreement !== 'Y');
    let prePayAgts = actSvcAgts.filter(item => item.ServiceAgreementType === Keywords.prePay); 
    let easyPayAgts = actSvcAgts.filter(item => item.ServiceAgreementType === Keywords.easyPay);  
    let oneTimeAgts = actSvcAgts.filter(item => item.ServiceAgreementType === Keywords.oneTime); 
    let prePayInactAgts = inActSvcAgts.filter(item => item.ServiceAgreementType === Keywords.prePay); 
    let easyPayInactAgts = inActSvcAgts.filter(item => item.ServiceAgreementType === Keywords.easyPay);  
    let oneTimeInactAgts = inActSvcAgts.filter(item => item.ServiceAgreementType === Keywords.oneTime); 
    salesAgreements.push(...badDebtAgts,...prePayAgts,...easyPayAgts,...spslAgts,...oneTimeAgts,...prePayInactAgts,...easyPayInactAgts,...oneTimeInactAgts);
  }
  return salesAgreements;
};

const invoiceAmountDue = (item) => {
  if(item && item.Invoices.length > 0){
    let invoiceOpen = item.Invoices.filter((x) => x.invoiceOpen === "Y");
    var totalInvoiceBalance = 0.00
    for(var i = 0; i < invoiceOpen.length; i++) { 
      totalInvoiceBalance += invoiceOpen[i].invoiceBalance;
    }
    return totalInvoiceBalance.toFixed(2);
  }
  return 0;
}

//Determine last payment date and amount for EasyPay Services
const calculateLastPayment = (invoice) => {
  let invoiceDate = 'N/A';
  let amount = 0;
  try{
    if (Array.isArray(invoice)) {
      invoice = invoice.sort(function (a, b) {
        return new Date(a.invoiceDate) - new Date(b.invoiceDate);
      });
      invoice=invoice.reverse();
      if (invoice.length > 0) {
        invoiceDate = formatDateMDYYYY(invoice[0].invoiceDate);
        amount = invoice[0].invoiceAmount - invoice[0].invoiceBalance;
      }
    }
  } 
  catch{
    //continue with default amount and date
  }
  return {
    amount,
    invoiceDate
  };
};


//Getting data from local storage. If paymentflag is true service agreements filter as per arbalnce>0
const getDataFromLocalStorage = (accountdetails, paymentflag) => {
  const selectedAdd = Storage.serviceAddress();
  const customerNumber = Storage.customerNumber();
  const displayPrePayButton = Storage.displayPrePayButton();
  const displayEasyPayButton = Storage.displayEasyPayButton();
  let serviceAgreements = [];
  if(accountdetails && accountdetails.SalesAgreements){
    serviceAgreements = getServiceAgreements(accountdetails.SalesAgreements, paymentflag);
  }
  
  const  { prePaydiscAmt, manageEasyPay } = easyPrePayButton(serviceAgreements);
  if(serviceAgreements.length>0 && paymentflag){
    let speduPrePayAgts = serviceAgreements.filter(item => item.ServiceAgreementType !== Keywords.easyPay && item.autoChgAcctRef && item.inactiveStatus === 'ACT');
    let svcAgreements = serviceAgreements.filter(item => (item.ServiceAgreementType === Keywords.easyPay && item.arBalance === 0 && item.inactiveStatus === 'ACT') || item.arBalance > 0);
    let spslPaymentAgts = serviceAgreements.filter(item => item.arBalance === 0 && item.inactiveReason === 'SSP' && item.inactiveStatus === 'INA' && item.ServiceAgreementType === Keywords.easyPay);
    let badDebtAgts = serviceAgreements.filter(item => item.isBadSalesAgreement === 'Y' && invoiceAmountDue(item) > 0 && item.inactiveReason !== 'SSP' && item.inactiveReason !== 'NRN');
    speduPrePayAgts.push(...svcAgreements);
    speduPrePayAgts.push(...spslPaymentAgts);
    speduPrePayAgts.push(...badDebtAgts);
    serviceAgreements = speduPrePayAgts;
  }
  
  return {
    selectedAdd,
    displayPrePayButton,
    displayEasyPayButton,
    customerNumber: customerNumber,
    selectedcustomer: Storage.customerSummaryObj(),
    customerDetails: Storage.customerSummary(),
    serviceAgreements,
    prePaydiscAmt,
    manageEasyPay
  };
};

//Method is used in payment container to dispaly PrePay and EasyPay Banner
const easyPrePayButton = salesAgreements => {
  let prePaydiscAmt = 0;
  let manageEasyPay = 0;
  try {
    salesAgreements=(salesAgreements || []).filter(item => item.isBadSalesAgreement === 'N' && item.inactiveStatus === 'ACT');
    manageEasyPay  = easyPayCalculate(salesAgreements,true).nonEasyPaySvcAg.length;
    const discSaleAgreement = salesAgreements.filter(item => item.PrePay.length > '0' && item.ServiceAgreementType !== Keywords.prePay && item.arBalance>0 || (item.arBalance===0 && item.ServiceAgreementType === Keywords.easyPay));
    prePaydiscAmt = discSaleAgreement.map(item => item.PrePay[0].yiaDiscAmt);
    prePaydiscAmt = -1 * ((prePaydiscAmt.reduce((a, b) => a + b)).toFixed(2));
  } catch {
    //continue with false values
  }
  return { prePaydiscAmt, manageEasyPay };
};

//Used to count ontime agreements for Monthly Billing without pseudoEasyPay
const oneTimeSalesAgreements = (salesAgreeement) =>{
  let oneTimeAgreement =[];
  let  oneTimeCount = 0;
  oneTimeAgreement=((salesAgreeement || []).filter(item => (item.ServiceAgreementType=== 'OneTime' &&  item.isBadSalesAgreement === 'N' && item.inactiveStatus === 'ACT')));
  oneTimeCount=oneTimeAgreement.length;
  return {oneTimeAgreement,oneTimeCount};
};

//Calculate EasyPay Agreements for account Settings
const easyPayCalculate = (salesAgreeement) =>{
  let easyPaySvcAg = (salesAgreeement || []).filter(item => ( (item.ServiceAgreementType === 'EasyPay' || (item.ServiceAgreementType !== 'EasyPay' && item.autoChgAcctRef) ) && item.inactiveStatus === 'ACT'  && item.isBadSalesAgreement === 'N' ));
  let nonEasyPaySvcAg = (salesAgreeement || []).filter(item => ( ( item.ServiceAgreementType !== 'EasyPay' && !item.autoChgAcctRef)  && item.inactiveStatus === 'ACT' && item.isBadSalesAgreement === 'N' ));
  return {easyPaySvcAg,nonEasyPaySvcAg};
};


const filterAgreement = (address, oneTimeAgreement) => {
  let filterAgree = [];
  filterAgree = oneTimeAgreement.filter(agree => agree.svcAddressLine1 === address);
  return filterAgree;
};

export {
  getServiceAgreements,
  filterAgreement,
  oneTimeSalesAgreements,
  easyPayCalculate,
  getDataFromLocalStorage,
  calculateLastPayment,
  easyPrePayButton,
  invoiceAmountDue
};